import classNames from 'classnames';

export const HorizontalDivider: React.FC<{ className?: string }> = ({ className }) => {
  return <div className={classNames('bg-linear-to-r from-gray-gallery-darker h-0.25 -mx-3 my-3', className)} />;
};

export const GrayGradientDivider: React.FC<{ className?: string }> = ({ className }) => {
  return <div className={classNames('bg-linear-to-r from-gray-gallery-darker h-0.25', className)} />;
};
